'use client';

import { type FC, useState, type PropsWithChildren } from 'react';

import styles from './styles.module.css';

export interface TooltipProps extends PropsWithChildren {
	content: string;
	delay?: number;
}

export const Tooltip: FC<TooltipProps> = ({ children, content, delay }) => {
	let timeout: NodeJS.Timeout;
	const [active, setActive] = useState(false);

	const showTip = () => {
		timeout = setTimeout(() => {
			setActive(true);
		}, delay || 400);
	};

	const hideTip = () => {
		clearInterval(timeout);
		setActive(false);
	};

	return (
		<div
			className={styles.wrapper}
			onMouseEnter={showTip}
			onMouseLeave={hideTip}
		>
			{active && <div className={styles.tooltip}>{content}</div>}
			{children}
		</div>
	);
};
